import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { setSlice } from '@store/trends/birdChart/actions';
import { useDispatch, useSelector } from 'react-redux';
import { intervalSelector } from '@store/common/selectors';
import { activeTabAtom, panelLoadingStateAtom, sliceAreaAtom, Tabs, zoomAreaAtom } from '../atoms';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { brushSelector } from '@store/trends/birdChart/selectors';
import useFirstRender from '@src/hooks/utils/useFirstRender';
import { isTableCompareEnabledAtom } from '@src/components/dimension-panel-hz/atoms/index';
import { Space } from 'antd';
import { StyledSpinner, StyledTag } from './styled';
import { tid } from '@utils/test';

const isZoomed = (zoomArea) => {
  return !isEmpty(zoomArea) && 'startValue' in zoomArea && 'endValue' in zoomArea;
};

function StateTags() {
  const [sliceArea, setSliceArea] = useAtom(sliceAreaAtom);
  const [zoomArea, setZoomArea] = useAtom(zoomAreaAtom);
  const activeTab = useAtomValue(activeTabAtom);

  const dispatch = useDispatch();
  const interval = useSelector(intervalSelector);
  const brush = useSelector(brushSelector);
  const tableCompareToggle = useSetAtom(isTableCompareEnabledAtom);
  const panelLoading = useAtomValue(panelLoadingStateAtom);

  const first = useFirstRender();

  const clearSlice = () => {
    setSliceArea([]);
    dispatch(setSlice([0, 100], [0, 0]));
    tableCompareToggle(false);
  };

  const clearZoom = () => {
    setZoomArea({ start: 0, end: 100 });
  };

  useEffect(() => {
    if (!first) {
      clearSlice();
      clearZoom();
    }
  }, [interval]);

  // workaround for restore trends workflow until diag section is cleaned up
  useEffect(() => {
    if (brush && (brush[0] || brush[1])) {
      setSliceArea(brush);
    }
  }, [brush]);

  return activeTab === Tabs.MetricCharts ? (
    <Space>
      <StyledSpinner size="small" spinning={panelLoading} {...tid('bg-loader')} />
      {!isEmpty(sliceArea) && (
        <StyledTag
          key="slice"
          onClick={clearSlice}
          onClose={clearSlice}
          closable
          style={{ cursor: 'pointer' }}
        >
          Slice
        </StyledTag>
      )}
      {isZoomed(zoomArea) && (
        <StyledTag
          key="zoom"
          onClick={clearZoom}
          onClose={clearZoom}
          closable
          style={{ cursor: 'pointer' }}
        >
          Zoom
        </StyledTag>
      )}
    </Space>
  ) : (
    <></>
  );
}

export default StateTags;
